module.exports = __webpack_public_path__ + "packs/media/images/pic01-69b874789fd8f1c5715561c9ef99f602.jpg";